import React from 'react';
import PropTypes from 'prop-types';

import DefaultModal from './DefaultModal';
import { userRoleCheckers } from '../../../../shared/helpers';

const pageNames = { outline: 'outline', sample: 'sample' };

const translationOptions = { ns: i18next.Namespace.COMMON };

const InterviewsNotCompletedModal = ({
  isShown,
  redirectToInterviews,
  redirectToSpecification,
  redirectToProjectOverview,
  userRole,
  pageName,
  isInterviewsNotCompleted,
}) => (userRoleCheckers.isWriter(userRole)
  ? (
    <DefaultModal
      isShown={isShown}
      closeModal={redirectToProjectOverview}
      title={!isInterviewsNotCompleted
        ? t(`interviewsNotCompletedModal.${pageName}.titleSpecification`, translationOptions)
        : t(`interviewsNotCompletedModal.${pageName}.title`, translationOptions)}
      message={!isInterviewsNotCompleted
        ? t(`interviewsNotCompletedModal.${pageName}.bookSpecificationsNotCompleted`, translationOptions)
        : t(`interviewsNotCompletedModal.${pageName}.${userRole}.msg`, translationOptions)}
      primaryBtnText={!isInterviewsNotCompleted
        ? t(`interviewsNotCompletedModal.${pageName}.btnTextSpecification`, translationOptions)
        : t(`interviewsNotCompletedModal.${pageName}.btnTextInterviews`, translationOptions)}
      primaryAction={!isInterviewsNotCompleted ? redirectToSpecification : redirectToInterviews}
      secondaryBtnText={t('button.cancel', translationOptions)}
      secondaryAction={redirectToProjectOverview}
    />
  )
  : userRoleCheckers.isEditor(userRole) || userRoleCheckers.isAdmin(userRole)
    ? (
      <DefaultModal
        isShown={isShown}
        closeModal={redirectToProjectOverview}
        title={!isInterviewsNotCompleted
          ? t(`interviewsNotCompletedModal.${pageName}.titleSpecification`, translationOptions)
          : t(`interviewsNotCompletedModal.${pageName}.title`, translationOptions)}
        message={!isInterviewsNotCompleted
          ? t(`interviewsNotCompletedModal.${pageName}.bookSpecificationsNotCompleted`, translationOptions)
          : t(`interviewsNotCompletedModal.${pageName}.${userRole}.msg`, translationOptions)}
        primaryBtnText={!isInterviewsNotCompleted
          ? t(`interviewsNotCompletedModal.${pageName}.btnTextSpecification`, translationOptions)
          : t(`interviewsNotCompletedModal.${pageName}.btnTextInterviews`, translationOptions)}
        primaryAction={!isInterviewsNotCompleted ? redirectToSpecification : redirectToInterviews}
        secondaryBtnText={t('button.ok', translationOptions)}
        secondaryAction={redirectToProjectOverview}
      />
    )
    : null);

InterviewsNotCompletedModal.propTypes = {
  isShown: PropTypes.bool,
  redirectToInterviews: PropTypes.func.isRequired,
  redirectToSpecification: PropTypes.func.isRequired,
  redirectToProjectOverview: PropTypes.func.isRequired,
  userRole: PropTypes.string,
  pageName: PropTypes.oneOf(Object.values(pageNames)).isRequired,
  isInterviewsNotCompleted: PropTypes.bool,
};

InterviewsNotCompletedModal.defaultProps = {
  isShown: false,
  userRole: '',
  isInterviewsNotCompleted: false,
};

export default InterviewsNotCompletedModal;
